// src/utils/publicApi.ts
import axios from 'axios';

// Public API instance - no credentials needed
export const publicApi = axios.create({
  baseURL: 'https://api.tms.hockey',
  withCredentials: false, // No credentials for public endpoints
});
